import { render, staticRenderFns } from "./ExceptionTableBulk.vue?vue&type=template&id=2a273a48&scoped=true&"
import script from "./ExceptionTableBulk.vue?vue&type=script&lang=js&"
export * from "./ExceptionTableBulk.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionTableBulk.vue?vue&type=style&index=0&id=2a273a48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a273a48",
  null
  
)

export default component.exports